import { useEffect } from "react";
import { showPendingDeletedNotice } from "@/lib/accountDeletedNotice";

/** FP-126: shows the account-deletion sentences after sign-out's reload. */
export function PendingDeletedNotice() {
  useEffect(() => {
    let store: Storage | undefined;
    try {
      store = window.sessionStorage;
    } catch {
      store = undefined;
    }
    showPendingDeletedNotice(store);
  }, []);
  return null;
}
